var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { background: "#fff" } },
    [
      _c("learnCardBind", {
        attrs: { value: _vm.showLearnCardBind },
        on: {
          "update:value": function($event) {
            _vm.showLearnCardBind = $event
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "new_content" }, [
        _c("div", { staticClass: "new_project_detail" }, [
          _c("div", { staticClass: "npd_info" }, [
            _c("div", { staticClass: "npdi_pic" }, [
              _c("img", { attrs: { src: _vm.projInfo.iamge } })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "npdi_txt" },
              [
                _c("div", { staticClass: "npdit1" }, [
                  _vm._v(_vm._s(_vm.projInfo.projectName))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "npdit2" }, [
                  _vm._v(
                    "项目负责人：" +
                      _vm._s(_vm.projInfo.nickName) +
                      "　　　　单位：" +
                      _vm._s(_vm.projInfo.companyId)
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "npdit2" }, [
                  _vm._v(
                    "项目类别：" +
                      _vm._s(_vm.projInfo.projectCategoryName) +
                      "　　　　学分类别：" +
                      _vm._s(_vm.projInfo.creditCateggoryName) +
                      "　　　　学分：" +
                      _vm._s(_vm.projInfo.creditSetting) +
                      " 分"
                  )
                ]),
                _vm._v(" "),
                _vm.projInfo.projectDescription
                  ? [
                      _vm.showFullProjectDescription
                        ? _c("div", { staticClass: "npdit3" }, [
                            _c("div", { staticClass: "npdit_title" }, [
                              _vm._v("项目描述：")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "npdit_main" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.projInfo.projectDescription.length >= 42
                                      ? _vm.projInfo.projectDescription.substring(
                                          0,
                                          42
                                        ) + "..."
                                      : _vm.projInfo.projectDescription
                                  )
                                )
                              ]),
                              _vm.projInfo.projectDescription.length >= 42
                                ? _c(
                                    "a",
                                    {
                                      attrs: { href: "javascript:;" },
                                      on: { click: _vm.showFullDescription }
                                    },
                                    [_vm._v("展开")]
                                  )
                                : _vm._e()
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.showFullProjectDescription
                        ? _c("div", { staticClass: "npdit4" }, [
                            _c("div", { staticClass: "npdit_title" }, [
                              _vm._v("项目描述：")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "npdit_main" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.projInfo.projectDescription))
                              ]),
                              _c(
                                "a",
                                {
                                  attrs: { href: "javascript:;" },
                                  on: { click: _vm.hiddenFullDescription }
                                },
                                [_vm._v("收起")]
                              )
                            ])
                          ])
                        : _vm._e()
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.projInfo.projectTarget
                  ? [
                      _vm.showFullProjectTarget
                        ? _c("div", { staticClass: "npdit3" }, [
                            _c("div", { staticClass: "npdit_title" }, [
                              _vm._v("项目目标：")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "npdit_main" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.projInfo.projectTarget.length >= 42
                                      ? _vm.projInfo.projectTarget.substring(
                                          0,
                                          42
                                        ) + "..."
                                      : _vm.projInfo.projectTarget
                                  )
                                )
                              ]),
                              _vm.projInfo.projectTarget.length >= 42
                                ? _c(
                                    "a",
                                    {
                                      attrs: { href: "javascript:;" },
                                      on: { click: _vm.showFullTarget }
                                    },
                                    [_vm._v("展开")]
                                  )
                                : _vm._e()
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.showFullProjectTarget
                        ? _c("div", { staticClass: "npdit4" }, [
                            _c("div", { staticClass: "npdit_title" }, [
                              _vm._v("项目目标：")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "npdit_main" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.projInfo.projectTarget))
                              ]),
                              _c(
                                "a",
                                {
                                  attrs: { href: "javascript:;" },
                                  on: { click: _vm.hiddenFullTarget }
                                },
                                [_vm._v("收起")]
                              )
                            ])
                          ])
                        : _vm._e()
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "npdit2" }, [
                  _vm.projInfo.projState == 4
                    ? _c(
                        "a",
                        {
                          staticClass: "npdit2_added",
                          staticStyle: { color: "#fff" },
                          attrs: { href: "javascript:;", disabled: "disabled" }
                        },
                        [_vm._v("已授予学分")]
                      )
                    : _vm.projInfo.projState == 2
                    ? _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.applyScoreShow,
                              expression: "applyScoreShow"
                            }
                          ],
                          staticClass: "npdit2_sqxf",
                          staticStyle: { color: "#fff" },
                          attrs: { href: "javascript:;" },
                          on: {
                            click: function($event) {
                              return _vm.applyScore(
                                _vm.projInfo.creditCateggory,
                                _vm.projInfo.creditSetting
                              )
                            }
                          }
                        },
                        [_vm._v("申请学分")]
                      )
                    : _vm.projInfo.projState == 3
                    ? _c(
                        "a",
                        {
                          staticClass: "npdit2_sqxf",
                          staticStyle: { color: "#fff" },
                          attrs: { href: "javascript:;" },
                          on: {
                            click: function($event) {
                              return _vm.cancelApplyScore()
                            }
                          }
                        },
                        [_vm._v("取消申请学分")]
                      )
                    : _c(
                        "a",
                        {
                          staticClass: "npdit2_sqxf_not",
                          staticStyle: { color: "#fff" },
                          attrs: {
                            href: "javascript:;",
                            title: "未完成学习不能申请学分"
                          }
                        },
                        [_vm._v("申请学分")]
                      ),
                  _vm._v(" "),
                  _vm.projInfo.isOwn == 1
                    ? _c(
                        "a",
                        {
                          staticClass: "npdit2_added",
                          staticStyle: { color: "#fff" },
                          attrs: { href: "javascript:;" }
                        },
                        [_vm._v("已添加到我的项目")]
                      )
                    : _c(
                        "a",
                        {
                          staticClass: "npdit2_add",
                          staticStyle: { color: "#fff" },
                          attrs: { href: "javascript:;", id: "addMy" },
                          on: {
                            click: function($event) {
                              return _vm.addToMyProject()
                            }
                          }
                        },
                        [_vm._v("+ 添加到我的项目")]
                      )
                ])
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "nupmrm_content",
              staticStyle: { "min-height": "300px" }
            },
            [
              _c(
                "table",
                {
                  staticClass: "collapse ba br2 b--black-10 pv1 ph1",
                  staticStyle: { "text-align": "center", width: "100%" }
                },
                [
                  _c(
                    "tbody",
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _vm._l(_vm.courseList, function(item, index) {
                        return _c(
                          "tr",
                          { staticClass: "striped--near-white" },
                          [
                            _c(
                              "td",
                              {
                                staticClass: "pv1 ph0",
                                staticStyle: { "text-align": "center" }
                              },
                              [_vm._v(_vm._s(index + 1))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "pv1 ph1",
                                staticStyle: { "text-align": "left" }
                              },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: item.name,
                                      placement: "top-start"
                                    }
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "course_name overflow",
                                        attrs: {
                                          href: "javascript:;",
                                          title: item.name
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.openVideoware(item.id)
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("td", { staticClass: "pv1 ph1" }, [
                              _vm._v(_vm._s(item.nickName))
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "pv1 ph1" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.courseStateComputed(item.courseState)
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "pv1 ph0" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "k1",
                                  staticStyle: { "padding-right": "0px" },
                                  attrs: { href: "javascript:;" },
                                  on: {
                                    click: function($event) {
                                      return _vm.openVideoware(item.id)
                                    }
                                  }
                                },
                                [_vm._v("视频")]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "pv1 ph0",
                                attrs: { width: "10%" }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "k3",
                                    staticStyle: { "padding-right": "0px" },
                                    attrs: { href: "javascript:;" },
                                    on: {
                                      click: function($event) {
                                        return _vm.haveBandedLearningCard(
                                          _vm.$route.query.trainingId,
                                          _vm.$route.query.projectId,
                                          item.id,
                                          item.courseFieldID,
                                          _vm.$route.query.setTop,
                                          item.name
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                考试[" +
                                        _vm._s(
                                          typeof item.practiseScore !=
                                            "undefined" &&
                                            item.practiseScore != null
                                            ? "最高" + item.practiseScore + "分"
                                            : "未考"
                                        ) +
                                        "]\n              "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("td", { staticClass: "pv1 ph0" }, [
                              item.handoutNull
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "k2-2",
                                      staticStyle: { "padding-right": "0px" },
                                      attrs: { href: "javascript:;" }
                                    },
                                    [_vm._v("讲义[无]")]
                                  )
                                : _c(
                                    "a",
                                    {
                                      staticClass: "k2",
                                      staticStyle: { "padding-right": "0px" },
                                      attrs: { href: "javascript:;" },
                                      on: {
                                        click: function($event) {
                                          return _vm.openCourseware(
                                            _vm.$route.query.trainingId,
                                            _vm.$route.query.projectId,
                                            item.id
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("讲义")]
                                  )
                            ])
                          ]
                        )
                      })
                    ],
                    2
                  )
                ]
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "tr",
      { staticClass: "striped--near-white", staticStyle: { height: "33px" } },
      [
        _c(
          "th",
          {
            staticClass: "pv1 ph3 tl f6 fw6 ttu",
            staticStyle: { "text-align": "center" },
            attrs: { width: "10%" }
          },
          [_vm._v("序号")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticClass: "f6 ttu fw6 pv1 ph1", attrs: { width: "40%" } },
          [_vm._v("课程名称")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticClass: "f6 ttu fw6 pv1 ph1", attrs: { width: "10%" } },
          [_vm._v("主讲人")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticClass: "f6 ttu fw6 pv1 ph1", attrs: { width: "10%" } },
          [_vm._v("课程状态")]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticClass: "f6 ttu fw6 pv1 ph0",
            attrs: { colspan: "30%", width: "" }
          },
          [_vm._v("操作")]
        )
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-350dbc32", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-350dbc32","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectInfo.vue
// module id = null
// module chunks = 